export type ViewportAnchoredRightSidebarPosition = {
  top: number
  height: number
  right: number
}

export function getViewportAnchoredRightSidebarPosition(
  rect: Pick<DOMRect, 'top' | 'height' | 'right'>,
  viewportWidth: number
): ViewportAnchoredRightSidebarPosition {
  return {
    top: rect.top,
    height: rect.height,
    right: Math.max(0, viewportWidth - rect.right),
  }
}
